export default __webpack_public_path__ + "static/media/gloryforkorn--og--privacy.2abbf3ff.jpg";